import UploadCertificateWithPassword from './UploadCertificateWithPassword';
import type { UploadCertificateWithPasswordProps } from './types';

export default UploadCertificateWithPassword;
export type { UploadCertificateWithPasswordProps };
